export const LT_DEBT_DATA_RECEIVED = 'LT_DEBT_DATA_RECEIVED'
export const LT_DEBT_RECEIVED = 'LT_DEBT_RECEIVED'
export const LT_DEBT_SAVED = 'LT_DEBT_SAVED'
export const LT_DEBT_DELETED = 'LT_DEBT_DELETED'
export const LT_DEBT_UNLOADED = 'LT_DEBT_UNLOADED'
